import useAppStore from "@/Modules/App/Store";

import type { TherapistStore } from "@/Modules/Therapist/Store";
import type { AppStore } from "@/Modules/App/Store";
import type { TherapistDeleteEducationApiQuery } from "@/Modules/Models/Api/Therapist";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import TherapistApiConnector from "@/Services/TherapyApi/Therapists";

class DeleteEducationActionHandler {
  constructor(
    private readonly therapistStore: TherapistStore,
    private readonly appStore: AppStore = useAppStore(),
    private readonly therapistApiConnector = new TherapistApiConnector()
  ) {}

  public async handle(deleteEducationQuery: TherapistDeleteEducationApiQuery) {
    try {
      this.therapistStore.isLoading = true;

      await this.therapistApiConnector.deleteTherapistEducation(deleteEducationQuery);

      if (this.therapistStore.therapist?.educations.length) {
        this.therapistStore.therapist.educations = this.therapistStore.therapist?.educations.filter(
          (education) => education.uuid !== deleteEducationQuery.uuid
        );
      }

      this.appStore.showSnackbar({
        type: NotificationType.SUCCESS,
        message: "settings.configuration.educations.notification.delete.success",
      });
    } catch (error: unknown) {
      this.appStore.showSnackbar({
        type: NotificationType.ERROR,
        message: "settings.configuration.educations.notification.error",
      });
    } finally {
      this.therapistStore.isLoading = false;
    }
  }
}

export default DeleteEducationActionHandler;
